import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-slate-200">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 text-center sm:px-6 md:grid-cols-3 md:text-left lg:px-8">
        <div className="mx-auto max-w-sm md:mx-0">
          <img
            src="/Wayroot (1600 x 500 px).svg"
            alt="Wayroot"
            className="mx-auto h-9 w-auto md:mx-0 md:h-10"
          />
          <p className="mt-4 text-sm text-slate-600">
            Wayroot simplifies multi-car reservations for events, corporates, and group travel
            with live availability, true time-based reservations, and transparent pricing.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-slate-900">Product</h4>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li>
              <Link to="/discover" className="hover:text-slate-900">
                Schedule Trip
              </Link>
            </li>
            <li>
              <Link to="/my-bookings" className="hover:text-slate-900">
                My Bookings
              </Link>
            </li>
            <li>
              <Link to="/cart" className="hover:text-slate-900">
                Cart
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-slate-900">Company</h4>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li>
              <Link to="/about-wayroot" className="hover:text-slate-900">
                About
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="hover:text-slate-900">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/delete-account" className="hover:text-slate-900">
                Delete Account
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-slate-900">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 px-4 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Wayroot. All rights reserved.
      </div>
    </footer>
  );
}
